export const templates = {
  Selector: 'Selector',
  Tab: 'Tab',
};
